export default {
  RESET_STORE(state) {
    state.loading = false
    state.settings = null
    state.lowerFee = null
    state.upperFee = null
  },

  SET_LOADING(state, value) {
    state.loading = value
  },

  SET_SETTINGS(state, settings) {
    state.settings = settings
  },

  SET_FEES(state, { lowerFee, upperFee }) {
    state.lowerFee = lowerFee
    state.upperFee = upperFee
  },
}
